export default abstract class PrimitiveValueObject<T, TPrimitive, TJSON> {
  protected constructor(_: TPrimitive) {};
  abstract toJSON(): TJSON;
  abstract isEqualTo(other: T | null | undefined): boolean;
  abstract toString(): string;
  abstract value: TPrimitive;
  abstract valueOf(): TPrimitive;
}